<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <h1>Page not Found.</h1>
          <v-btn color="primary" class="px-10" @click="goBack">Go back</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goBack() {
      if (this.getHomeLink) {
        this.$router.push(this.getHomeLink);
        return;
      }
      this.$router.push("/");
    },
  },

  computed: {
    // userData() {
    //   return this.$store.getters.userData;
    // },

    // getDashboardRole() {
    //   return this.$store.getters.dashboardRole;
    // },

    getHomeLink() {
      return this.$store.getters.getHomeLink;
    },
  },
};
</script>
